import React, { useRef, useEffect, useState, forwardRef } from 'react'
import { motion, usePresence, AnimatePresence } from 'framer-motion'
import TextareaAutosize from 'react-textarea-autosize'
import ClickAwayListener from 'react-click-away-listener'
import useWindowSize from '@/utils/useWindowSize'

function ItemAdd(
  {
    newTaskContent,
    newTaskOnEnter,
    placeholder,
    newTaskTextChange,
    hideButton,
    clickAway,
  },
  ref
) {
  const ceNewTask = useRef()
  const [getMounted, setMounted] = useState(false)
  const windowSize = useWindowSize()

  // console.log('ref', ref)

  useEffect(() => {
    // ceNewTask.current.focus()
    setMounted(true)
    if (ceNewTask) {
      const offset = 200
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = ceNewTask.current.getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      if (window.innerWidth < 900) {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      }
    }
  }, [])

  const handleClickAway = () => {
    // only allow click away once mounted & focus'd
    if (getMounted) {
      clickAway()
    }
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <motion.div
        ref={ref}
        initial="hidden"
        animate="visible"
        exit="exit"
        variants={{
          hidden: {
            opacity: 0,
            scale: 0.95,
          },
          visible: {
            opacity: 1,
            scale: 1,
          },
          exit: {
            opacity: 0,
            scale: 0.95,
          },
        }}
        className="addNewListItemQuill shadow-xl"
      >
        <TextareaAutosize
          ref={ceNewTask}
          autoFocus
          className="block resize-none  newTaskItem TaskItemText  font-medium	 w-full  outline-none"
          onKeyDown={e => {
            newTaskOnEnter(e)
          }}
          value={newTaskContent}
          placeholder={placeholder}
          onChange={evt => {
            newTaskTextChange(evt)
          }}
        />

        <div className="flex items-center justify-between mt-2">
          <div className="text-xs opacity-50">* press enter to add...</div>
          <div
            onClick={() => {
              hideButton()
            }}
            className="text-sm opacity-50"
          >
            cancel
          </div>
        </div>
      </motion.div>
    </ClickAwayListener>
  )
}

export default forwardRef(ItemAdd)
